import React from 'react';

class LookerFrame extends React.Component {
    render() {
        return (
            <iframe scrolling="no" seamless="seamless" title="dashboard" src={this.props.frameSrc} allowFullScreen className="dash-frame"></iframe>
        );
    }
}

export default LookerFrame;